import React, { useContext } from "react";
import { Lightbulb } from "lucide-react";
import { ThemeContext } from "../../../../constant/theme";
import { LanguageContext } from "../../../../constant/LanguageContext";
import text from "../../constants/reportsTranslations";
import InsightCard from "./InsightCard";
import { SkeletonBox } from "../../../../components/SkeletonLoader";

const labelKey = (key) => `insight${key.charAt(0).toUpperCase()}${key.slice(1)}`;

const InsightsSection = ({ insights, insightsLoading }) => {
  const { theme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext);
  const isDark = theme === "dark";
  const isRTL = language === "ar";

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexDirection: isRTL ? "row-reverse" : "row" }}>
        <Lightbulb size={17} color="#f59e0b" />
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>
          {text[language].insightsTitle}
        </h2>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))", gap: 12 }}>
        {insightsLoading
          ? Array.from({ length: 8 }).map((_, i) => <SkeletonBox key={i} width="100%" height="88px" style={{ borderRadius: 14 }} />)
          : insights.map((insight) => (
              <InsightCard
                key={insight.key}
                insight={insight}
                theme={theme}
                isRTL={isRTL}
                label={text[language][labelKey(insight.key)] || insight.label}
              />
            ))}
      </div>
    </div>
  );
};

export default InsightsSection;
